import { Component, ViewChild } from '@angular/core';
import { UserSettingsStateService } from '../user-settings-state.service';
import { DialogComponent } from '../../../components/layout/dialog/dialog.component';

@Component({
  selector: 'app-newsletter-opt-in-dialog',
  templateUrl: './newsletter-opt-in-dialog.component.html',
  styleUrls: ['./newsletter-opt-in-dialog.component.scss'],
})
export class NewsletterOptInDialogComponent {
  @ViewChild(DialogComponent) dialog: DialogComponent;

  constructor(
    private userSettingsState: UserSettingsStateService,
  ) {
  }

  onYesClick() {
    this.userSettingsState.updateNewsletterOptIn(true).subscribe(
      () => this.dialog.close(),
    );
  }

  onNoClick() {
    this.userSettingsState.updateNewsletterOptIn(false).subscribe(
      () => this.dialog.close(),
    );
  }
}
